// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloudUploadOutlinedSvg from "@fishx/icons-svg/es/asn/PCloudUploadOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloudUploadOutlined = function PCloudUploadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloudUploadOutlinedSvg
  }));
};

PCloudUploadOutlined.displayName = 'PCloudUploadOutlined';
export default React.forwardRef(PCloudUploadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloudUploadOutlined.js
// module id = 3295
// module chunks = 0